/**
 * ★ Fase 59 — FUNNEL ES (Español · multi-país) — landing completa 9 secciones.
 * URL: /f/es — gemela del Funnel IT (/f/it) traducida al español.
 *
 * Differenze vs Funnel IT (richieste cliente):
 *  - VP ALBANIA: €1.000 (weekend) · date con 2 GIORNI DI ANTICIPO vs IT
 *    (derivate dal backend: label già in spagnolo).
 *  - EXTRA PASS privato Albania: €1.000.
 *  - TAILANDIA ATTIVA: €4.000 · SOLO privato · 9 días / 7 noches · todo
 *    incluido · Chumphon + Bangkok + Koh Tao (niente lista d'attesa).
 *  - Video per TERRITORIO: AL → VP Albania · ID → Lombok Journey · TH →
 *    video Thailandia (il cliente sostituirà i video ES in seguito).
 *  - Lead → funnel 'es' (CRM: Sofia Suarez). Chat in spagnolo (prompt ES).
 *  - Card Indonesia → mini-landing /f/es-ba e /f/es-lo (grafiche IT finché
 *    il cliente non invia le versioni ES).
 *  - ★ Fase 80 — Card Albania → landing dedicate ES (/f/es-al-na Narea con
 *    form interno che riporta qui con ?lead=ok&from=es-al-na · /f/es-al-tg
 *    Three Garden → form → Calendly). Lead ES-AL-NA / ES-AL-TG → Sofia.
 */
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import i18n from '../../../i18n';
import { api } from '../../../lib/api';
import { toast } from 'sonner';
import {
  ArrowRight, Landmark, BarChart3, Layers, MapPin, FileCheck2, Users,
  PlayCircle, Network, BedDouble, CalendarClock, Send, Loader2,
  CheckCircle2, Palmtree, Building2, ShieldCheck, Star, Circle,
  User, Mail, Phone, X,
} from 'lucide-react';
import FunnelChatWidget from '../../../components/FunnelChatWidget';
import { testimonialsFor, TESTIMONIALS_FEATURED_COUNT } from '../../../lib/testimonials';
import { setPageMeta, ogImageFor } from '../../../lib/seo';
import { IndonesiaAssetCards } from '../../../components/funnels/IndonesiaAssetCards';
import { VpVideoPlaylist } from '../../../components/funnels/VpVideoPlaylist'; // ★ 2026-10-22 — video VP per territorio (Albania: 3)
import { vpVideosFor } from '../../../lib/vpVideos';
import { useHashScroll } from '../../../lib/useHashScroll'; // ★ Fase 94 — /f/xx#verification dal bridge Three Garden
// ★ Fase 96 (Doc 02) — doppio ingresso + scelta guidata + attribution/eventi
import { captureAttribution, trackFunnelEvent } from '../../../lib/attribution';
import { HubGuidedChoice } from '../../../components/funnels/HubGuidedChoice';
import { NoObligationNote } from '../../../components/funnels/NoObligationNote';

const INK = '#081712';
const EMERALD = '#0C2B21';
const GOLD = '#D6B25E';
const GOLD_DEEP = '#B8860B';
const IVORY = '#F4EEE1';
const SAND = '#CFC6B2';

/* ── Video flow (il cliente li sostituirà con le versioni ES) ── */
const PRE_VSL_ID = 'j9_HhKF2xgA';        // il sistema HCF in 5 minuti
const VSL_ID = 'oNrux7V3TzM';            // VSL → promuove il Verification Pass
/* Video per TERRITORIO sotto la lista paesi */
const TERRITORY_VIDEOS = {
  AL: { id: 'DEEz5eXicGU', title: 'Verification Pass Albania' },
  ID: { id: 'V0Z643ZA4Pg', title: 'HCF — The Lombok Journey' },
  TH: { id: 'VvZqwA1ZSOU', title: 'HCF — Tailandia' },
};
// ★ 2026-10-19 — fuente única (13 vídeos) en lib/testimonials.js: 4 destacados + el resto bajo demanda
const TESTIMONIALS = testimonialsFor('es');
const TESTIMONIALS_FEATURED = TESTIMONIALS.slice(0, TESTIMONIALS_FEATURED_COUNT);
const TESTIMONIALS_MORE = TESTIMONIALS.slice(TESTIMONIALS_FEATURED_COUNT);

/* Calendly diretto del CEO — valore live da GET /public/funnel/es (booking_url). */
const CALENDLY_RICHARD = 'https://calendly.com/legal-housecashflows/colloquio-strategico-con-il-ceo-di-hcf-group';

/* ── Fallback locali date (fonte primaria = CRM via /public/funnel/es) ──
   Albania ES: date IT con 2 giorni di anticipo (label spagnoli). */
const VP_DATES = [
  { id: 'oct', label: '21–23 Octubre', start: '2026-10-21', total: 24, left: 14 },
  { id: 'nov1', label: '4–6 Noviembre', start: '2026-11-04', total: 24, left: 18 },
  { id: 'nov2', label: '18–20 Noviembre', start: '2026-11-18', total: 24, left: 22 },
  { id: 'dic', label: '2–4 Diciembre', start: '2026-12-02', total: 24, left: 18 },
];

/* Extra Pass privado (entre semana · €1.000 · máx 5 inversores) */
const VP_EXTRA_DATES = [
  { id: 'oct-x', label: '25–27 Octubre', start: '2026-10-25', max: 5 },
  { id: 'nov1-x', label: '8–10 Noviembre', start: '2026-11-08', max: 5 },
  { id: 'nov2-x', label: '22–24 Noviembre', start: '2026-11-22', max: 5 },
  { id: 'dic-x', label: '13–15 Diciembre', start: '2026-12-13', max: 5 },
];

/* Indonesia: €5.000 · 9 días / 7 noches · 12 plazas */
const VP_DATES_ID = [
  { id: 'id-1', label: '15–23 Octubre', start: '2026-10-15', total: 12, left: 0 },
  { id: 'id-2', label: '29 Oct – 6 Nov', start: '2026-10-29', total: 12, left: 4 },
  { id: 'id-3', label: '12–20 Noviembre', start: '2026-11-12', total: 12, left: 7 },
  { id: 'id-4', label: '26 Nov – 4 Dic', start: '2026-11-26', total: 12, left: 9 },
  { id: 'id-5', label: '10–18 Diciembre', start: '2026-12-10', total: 12, left: 11 },
];

/* ★ Tailandia ATTIVA nel funnel ES: €4.000 · privato · plazas reali */
const VP_DATES_TH = [
  { id: 'th-1', label: '15–23 Octubre', start: '2026-10-15', total: 12, left: 3 },
  { id: 'th-2', label: '29 Oct – 6 Nov', start: '2026-10-29', total: 12, left: 6 },
  { id: 'th-3', label: '12–20 Noviembre', start: '2026-11-12', total: 12, left: 9 },
  { id: 'th-4', label: '26 Nov – 4 Dic', start: '2026-11-26', total: 12, left: 12 },
  { id: 'th-5', label: '10–18 Diciembre', start: '2026-12-10', total: 12, left: 12 },
];

const VP_COUNTRIES = {
  AL: {
    name: 'Albania', price: '€1.000', rateLabel: 'Private Rate · Fin de semana', eventDays: 3,
    desc: 'Acceso completo a los datos, análisis del territorio y oportunidades seleccionadas en el mercado albanés.',
    lockCta: 'Bloquea el Private Rate €1.000',
  },
  ID: {
    name: 'Indonesia', price: '€5.000', rateLabel: 'Private Rate · 9 días · 7 noches', eventDays: 9,
    desc: 'Verificación extendida sobre el terreno: 9 días y 7 noches entre activos, obras y territorio en el mercado indonesio.',
    lockCta: 'Bloquea el Private Rate €5.000',
  },
  TH: {
    name: 'Tailandia', price: '€4.000', rateLabel: 'Private Rate · Solo privado · 9 días · 7 noches', eventDays: 9,
    desc: 'Verificación privada TODO INCLUIDO: 9 días y 7 noches entre Chumphon, Bangkok y Koh Tao — activos, territorio y experiencia directa.',
    lockCta: 'Bloquea el Private Rate €4.000',
  },
};

/* ── Card producto Indonesia (mini-landing dedicate /f/es-ba, /f/es-lo) ── */
const INDONESIA_CARDS = [
  {
    slug: 'villa-flora', place: 'Bali · Indonesia', name: 'Villa Flora',
    tagline: 'Villa íntima con piscina privada, interiores luminosos y diseño boho-minimal. Un rincón privado y tropical.',
    facts: ['Piscina privada', 'Interiores luminosos', 'Diseño boho-minimal'],
    cover: '/funnels/indonesia/villa-flora/card-cover.webp', coverPosition: 'center 40%',
    href: '/f/es-ba',
  },
  {
    slug: 'green-paradise-lombok', place: 'Lombok · Bumbang Bay', name: 'Green Paradise',
    tagline: 'Resort eco-luxury frente al océano con playa privada: 32 villas privadas gestionadas como resort.',
    facts: ['32 villas privadas', 'Frente al océano', 'Apertura oct. 2027'],
    cover: '/funnels/indonesia/green-paradise-lombok/photos/gp-cover.webp', coverPosition: 'center 45%',
    href: '/f/es-lo',
  },
];

/* ── ★ Fase 80 — Landing dedicate ES per asset Albania (form interno →
   lead ES-AL-NA / ES-AL-TG → Sofia). Narea riporta qui con ?lead=ok&from=;
   Three Garden va dritto al Calendly. Accettiamo sia gli slug ES che quelli IT. */
const ASSET_LANDING_HREF = {
  'es-narea': '/f/es-al-na',
  'narea': '/f/es-al-na',
  'es-three-garden-qerret': '/f/es-al-tg',
  'three-garden-qerret': '/f/es-al-tg',
};

/* ── Countdown automatico sulla prossima data VP ── */
function useVpCountdown(dates, eventDays = 3) {
  const calc = () => {
    const list = dates && dates.length ? dates : VP_DATES;
    const now = Date.now();
    for (const d of list) {
      const startT = new Date(`${d.start}T09:00:00`).getTime();
      const endT = startT + eventDays * 86400000;
      if (now < startT) return { date: d, left: startT - now, running: false };
      if (now < endT) return { date: d, left: 0, running: true };
    }
    const last = list[list.length - 1];
    return { date: last, left: 0, running: false };
  };
  const [st, setSt] = useState(calc);
  useEffect(() => {
    setSt(calc());
    const id = setInterval(() => setSt(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dates]);
  const s = Math.floor(st.left / 1000);
  return {
    date: st.date, running: st.running,
    d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60), s: s % 60,
  };
}

/* ── Barra di avanzamento scroll ── */
function ScrollProgress() {
  const [p, setP] = useState(0);
  useEffect(() => {
    let raf = 0;
    const update = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      setP(max > 0 ? Math.min(1, window.scrollY / max) : 0);
      raf = 0;
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
  return (
    <div className="h-[3px] w-full overflow-hidden" style={{ background: `${GOLD}1F` }} aria-hidden="true">
      <div
        className="h-full w-full origin-left"
        style={{
          transform: `scaleX(${p})`,
          background: `linear-gradient(90deg, ${GOLD_DEEP}, ${GOLD})`,
          boxShadow: `0 0 10px ${GOLD}66`,
          transition: 'transform 80ms linear',
        }}
        data-testid="es-scroll-progress"
      />
    </div>
  );
}

const Kicker = ({ children }) => (
  <div className="flex items-center gap-3 text-[11px] md:text-xs font-sans font-semibold tracking-[0.3em] uppercase" style={{ color: SAND }}>
    {children}
    <span className="inline-block w-10 border-t" style={{ borderColor: GOLD }} />
  </div>
);

const IvoryPill = ({ children, onClick, testId, className = '' }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center justify-center gap-2 rounded-full w-full sm:w-auto px-6 sm:px-8 py-3.5 text-[12px] sm:text-[13px] text-center font-sans font-bold tracking-[0.14em] sm:tracking-[0.2em] uppercase transition-transform duration-200 hover:scale-[1.02] active:scale-[0.99] ${className}`}
    style={{ background: IVORY, color: '#143C2B', boxShadow: `0 0 0 1px ${GOLD}, 0 8px 30px rgba(0,0,0,0.35)` }}
    data-testid={testId}
  >
    {children}<ArrowRight className="w-4 h-4" />
  </button>
);

const YT = ({ id, title, autoplay = false }) => (
  <iframe
    src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1${autoplay ? '&autoplay=1' : ''}`}
    title={title}
    className="w-full h-full"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  />
);

/* ── Campi "dark glass" + oro (stessa palette del funnel IT) ── */
const LUX_CSS = `
  .ital-lux-field { background: rgba(244,238,225,0.07); border: 1px solid rgba(214,178,94,0.30); color: #F4EEE1; caret-color: #D6B25E; transition: border-color .2s, box-shadow .2s, background-color .2s; }
  .ital-lux-field::placeholder { color: rgba(207,198,178,0.55); }
  .ital-lux-field:hover:not(:focus) { border-color: rgba(214,178,94,0.55); }
  .ital-lux-field:focus { border-color: #D6B25E; background: rgba(244,238,225,0.12); box-shadow: 0 0 0 3px rgba(214,178,94,0.20); outline: none; }
  .ital-gold-btn { background: linear-gradient(135deg, #E3C87A 0%, #D6B25E 45%, #B8860B 100%); color: #11271E; box-shadow: 0 10px 30px rgba(214,178,94,0.22), inset 0 1px 0 rgba(255,255,255,0.35); transition: transform .2s, box-shadow .2s; }
  .ital-gold-btn:hover:not(:disabled) { transform: scale(1.015); box-shadow: 0 14px 42px rgba(214,178,94,0.34), inset 0 1px 0 rgba(255,255,255,0.4); }
  .ital-gold-btn:active:not(:disabled) { transform: scale(0.99); }
  .ital-gold-btn:disabled { opacity: 0.5; }
`;

function LuxField({ icon: Icon, testId, ...props }) {
  return (
    <div className="relative">
      <Icon className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none" style={{ color: GOLD }} strokeWidth={1.6} />
      <input
        {...props}
        data-testid={testId}
        className="ital-lux-field w-full h-12 rounded-xl pl-11 pr-4 text-sm font-sans"
      />
    </div>
  );
}

function Scene({ n, children, minH = 'min-h-0', id }) {
  return (
    <section id={id} className={`relative ${minH} flex`} data-testid={`es-section-${n}`}>
      <div className="relative w-full max-w-6xl mx-auto px-5 md:px-8 py-12 md:py-16 flex flex-col">
        {children}
      </div>
    </section>
  );
}

/* ── Exit intent: último aviso (Calendly) antes de salir ── */
function ExitIntentModal({ calendly }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onOut = (e) => {
      if (e.clientY > 10 || e.relatedTarget) return;
      try {
        if (sessionStorage.getItem('hcf_es_exit_shown') === '1') return;
        sessionStorage.setItem('hcf_es_exit_shown', '1');
      } catch { /* no-op */ }
      setShow(true);
    };
    const onKey = (e) => e.key === 'Escape' && setShow(false);
    document.addEventListener('mouseout', onOut);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mouseout', onOut);
      document.removeEventListener('keydown', onKey);
    };
  }, []);
  if (!show) return null;
  return (
    <div
      className="fixed inset-0 z-[90] grid place-items-center p-4"
      style={{ background: 'rgba(4,10,8,0.72)', backdropFilter: 'blur(10px)' }}
      onClick={() => setShow(false)}
      data-testid="es-exit-modal"
    >
      <div
        className="relative w-full max-w-md rounded-2xl border p-7 md:p-8 text-center font-serif"
        style={{ borderColor: `${GOLD}77`, background: `linear-gradient(160deg, ${EMERALD}F8, ${INK}F5)`, boxShadow: '0 30px 90px rgba(0,0,0,0.6)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button" onClick={() => setShow(false)} aria-label="Cerrar"
          className="absolute top-3.5 right-3.5 w-8 h-8 rounded-full grid place-items-center border transition-colors duration-150 hover:bg-white/10"
          style={{ borderColor: `${GOLD}55`, color: SAND }}
          data-testid="es-exit-close"
        >
          <X className="w-4 h-4" />
        </button>
        <img src="/funnels/hcf-logo.png" alt="HCF Property" className="h-10 mx-auto" />
        <div className="mt-4 text-[11px] font-sans font-bold tracking-[0.3em] uppercase" style={{ color: GOLD }}>Antes de irte</div>
        <h3 className="mt-2 text-2xl md:text-3xl leading-snug" style={{ color: IVORY }}>
          Una última cosa:<br /><span style={{ color: GOLD }}>hablemos 15 minutos</span>
        </h3>
        <p className="mt-3 text-sm font-sans leading-relaxed" style={{ color: SAND }}>
          Sin obligación de compra: una <b style={{ color: IVORY }}>consultoría
          estratégica con tu Senior Associate</b> de HCF Group para entender
          si este recorrido es para ti.
        </p>
        <a
          href={calendly} target="_blank" rel="noopener noreferrer"
          className="ital-gold-btn mt-6 w-full rounded-full min-h-12 py-2.5 px-4 text-[11px] sm:text-[12px] font-sans font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2"
          data-testid="es-exit-calendly"
        >
          <CalendarClock className="w-4 h-4" /> Reserva la consultoría estratégica
        </a>
        <button
          type="button" onClick={() => setShow(false)}
          className="mt-3 w-full text-[12px] font-sans tracking-wide underline-offset-4 hover:underline"
          style={{ color: SAND }}
          data-testid="es-exit-continue"
        >
          Sigue leyendo la página
        </button>
      </div>
    </div>
  );
}

/* Card vídeo testimonio: thumbnail → play inline */
function TestimonialCard({ id, label, name }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="rounded-xl overflow-hidden border" style={{ borderColor: `${GOLD}55`, background: `${EMERALD}B3` }} data-testid={`es-testimonial-${id}`}>
      <div className="aspect-video relative">
        {playing ? (
          <YT id={id} title={label} autoplay />
        ) : (
          <button type="button" onClick={() => setPlaying(true)} className="group absolute inset-0 w-full" aria-label={`Ver: ${label}`} data-testid={`es-testimonial-play-${id}`}>
            <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt={label} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <span className="absolute inset-0" style={{ background: `${INK}59` }} />
            <span className="absolute inset-0 grid place-items-center">
              <span className="w-14 h-14 rounded-full grid place-items-center border transition-transform duration-200 group-hover:scale-110" style={{ borderColor: GOLD, background: `${INK}B3` }}>
                <PlayCircle className="w-8 h-8" style={{ color: GOLD }} strokeWidth={1.2} />
              </span>
            </span>
          </button>
        )}
      </div>
      <div className="px-4 py-3">
        <div className="font-serif text-base" style={{ color: IVORY }}>{label}</div>
        {name && <div className="mt-1 text-xs font-sans tracking-wide" style={{ color: GOLD }} data-testid={`es-testimonial-name-${id}`}>{name}</div>}
        <div className="mt-1.5 w-8 border-t" style={{ borderColor: GOLD }} />
      </div>
    </div>
  );
}

export default function FunnelES() {
  const [assets, setAssets] = useState([]);
  const [showAllTestimonials, setShowAllTestimonials] = useState(false); // ★ 2026-10-19
  const [calendly, setCalendly] = useState(CALENDLY_RICHARD);
  const [vpDates, setVpDates] = useState(VP_DATES);
  const [extraDates, setExtraDates] = useState(VP_EXTRA_DATES);
  const [territory, setTerritory] = useState('AL');
  const [vpDatesID, setVpDatesID] = useState(VP_DATES_ID);
  const [vpDatesTH, setVpDatesTH] = useState(VP_DATES_TH);

  // Countdown ID/TH: apuntan a la próxima fecha CON plazas disponibles
  const vpDatesIDOpen = useMemo(() => {
    const open = vpDatesID.filter((d) => (d.left ?? 0) > 0);
    return open.length ? open : vpDatesID;
  }, [vpDatesID]);
  const vpDatesTHOpen = useMemo(() => {
    const open = vpDatesTH.filter((d) => (d.left ?? 0) > 0);
    return open.length ? open : vpDatesTH;
  }, [vpDatesTH]);
  const vpAL = useVpCountdown(vpDates, VP_COUNTRIES.AL.eventDays);
  const vpID = useVpCountdown(vpDatesIDOpen, VP_COUNTRIES.ID.eventDays);
  const vpTH = useVpCountdown(vpDatesTHOpen, VP_COUNTRIES.TH.eventDays);
  const vp = territory === 'ID' ? vpID : territory === 'TH' ? vpTH : vpAL;
  const vpCountry = VP_COUNTRIES[territory] || VP_COUNTRIES.AL;
  const vpActiveDates = territory === 'ID' ? vpDatesID : territory === 'TH' ? vpDatesTH : vpDates;

  // Form hero
  const [gName, setGName] = useState('');
  const [gEmail, setGEmail] = useState('');
  const [gPhone, setGPhone] = useState('');
  const [gSending, setGSending] = useState(false);
  // ★ Fase 80 — se arrivo da una landing dedicata ES (/f/es-al-na) con
  // ?lead=ok il lead è GIÀ stato catturato: mostro subito la CTA di prenotazione.
  const [searchParams] = useSearchParams();
  const [gSent, setGSent] = useState(searchParams.get('lead') === 'ok');
  const leadFrom = searchParams.get('from') || '';
  const fromNarea = leadFrom === 'es-al-na' || leadFrom === 'it-al-na';
  const fromThreeGarden = leadFrom === 'es-al-tg' || leadFrom === 'it-al-tg';
  const assetFromName = fromNarea ? 'Narea' : fromThreeGarden ? 'Three Garden' : '';

  // Form final (dossier)
  const [fName, setFName] = useState('');
  const [fEmail, setFEmail] = useState('');
  const [fPhone, setFPhone] = useState('');
  const [fSending, setFSending] = useState(false);
  const [fSent, setFSent] = useState(false);
  // ★ Fase 96 (Doc 02) — ingresso aperto nella scelta guidata (la CTA primaria dell'hero apre «projects»)
  const [guideEntry, setGuideEntry] = useState(null);

  useEffect(() => {
    if (i18n.language !== 'es') i18n.changeLanguage('es');
    captureAttribution(); // ★ Fase 91/96 — utm_*, click_id, first_touch, landing_path preservati
    // ★ Fase 89 — meta social del funnel ES (thumbnail brand in spagnolo)
    setPageMeta({
      title: 'HCF Property — Del ladrillo al patrimonio',
      description: 'HCF Property — Del ladrillo al patrimonio. Verification Pass Albania: verifica territorio, activos y datos en vivo antes de invertir. Reserva tu consultoría estratégica.',
      image: ogImageFor('es'),
      imageAlt: 'HCF Property — Del ladrillo al patrimonio. Verification Pass Albania.',
      path: '/f/es',
      locale: 'es',
    });
    api.get('/public/funnel/es').then((r) => {
      setAssets(r.data?.properties || []);
      if (r.data?.booking_url) setCalendly(r.data.booking_url);
      if (Array.isArray(r.data?.vp_dates) && r.data.vp_dates.length) {
        setVpDates(r.data.vp_dates.map((d) => ({
          id: d.id, label: d.label, start: d.start,
          total: d.total ?? 24, left: d.left ?? 0,
        })));
      }
      if (Array.isArray(r.data?.vp_extra_dates) && r.data.vp_extra_dates.length) {
        setExtraDates(r.data.vp_extra_dates.map((d) => ({
          id: d.id, label: d.label, start: d.start, max: d.max_people ?? 5,
        })));
      }
      if (Array.isArray(r.data?.vp_dates_id) && r.data.vp_dates_id.length) {
        setVpDatesID(r.data.vp_dates_id.map((d) => ({
          id: d.id, label: d.label, start: d.start,
          total: d.total ?? 12, left: d.left ?? 0,
        })));
      }
      if (Array.isArray(r.data?.vp_dates_th) && r.data.vp_dates_th.length) {
        setVpDatesTH(r.data.vp_dates_th.map((d) => ({
          id: d.id, label: d.label, start: d.start,
          total: d.total ?? 12, left: d.left ?? 0,
        })));
      }
    }).catch(() => {});
  }, []);

  useHashScroll(); // ★ Fase 94 (Doc 02) — scroll alla sezione nell'hash (es. #verification)
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  // ★ Fase 96 — CTA primaria hero → apre la scelta guidata (step reale: orientamento, non vendita)
  const openGuide = (label) => {
    trackFunnelEvent('cta_click', { funnel: 'es', label, target: '#percorso-guidato' });
    setGuideEntry('projects');
    window.setTimeout(() => scrollTo('percorso-guidato'), 50);
  };
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const submitHero = async (e) => {
    e?.preventDefault();
    if (gName.trim().length < 2 || !emailRe.test(gEmail.trim()) || gSending) return;
    setGSending(true);
    try {
      await api.post('/public/funnel-lead', {
        funnel: 'es', name: gName.trim(), email: gEmail.trim(),
        phone: gPhone.trim() || null, message: 'Solicitud dossier Albania (form hero · funnel ES)',
      });
      setGSent(true);
      toast.success('¡Solicitud enviada!', { description: 'Recibirás el dossier: un Senior Associate te contactará en breve.' });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No se pudo enviar, inténtalo de nuevo.');
    } finally {
      setGSending(false);
    }
  };

  const submitFinal = async (e) => {
    e?.preventDefault();
    if (fName.trim().length < 2 || !emailRe.test(fEmail.trim()) || fSending) return;
    setFSending(true);
    try {
      await api.post('/public/funnel-lead', {
        funnel: 'es', name: fName.trim(), email: fEmail.trim(),
        phone: fPhone.trim() || null,
        message: `Solicitud dossier / Verification Pass ${vpCountry.name} (${vpCountry.price}) · funnel ES`,
      });
      setFSent(true);
      toast.success('¡Solicitud enviada!', { description: 'Un Senior Associate te contactará en breve.' });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'No se pudo enviar, inténtalo de nuevo.');
    } finally {
      setFSending(false);
    }
  };

  /* Card asset Albania — tagline override (slug ES e IT) */
  const assetCopy = {
    'es-narea': 'Nueva visión en la costa albanesa',
    'narea': 'Nueva visión en la costa albanesa',
    'es-three-garden-qerret': 'Frente al mar en Qerret: ubicación, percepción y valor',
    'three-garden-qerret': 'Frente al mar en Qerret: ubicación, percepción y valor',
  };
  /* ★ Fase 80 — card Albania → landing dedicata ES con form interno
     (tag ES-AL-NA / ES-AL-TG → Sofia). Fallback: scheda resort ES. */
  const assetHref = (slug) => ASSET_LANDING_HREF[slug] || `/es/resort/${slug}`;

  const sceneAssets = territory === 'AL' ? assets : [];

  return (
    <div className="relative min-h-screen font-serif" style={{ background: INK, color: IVORY }} data-testid="funnel-page-es">
      <style>{LUX_CSS}</style>
      {/* Sfondo unico scorrevole (stesso asset del funnel IT) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ zIndex: 0 }} aria-hidden="true">
        <img
          src="/funnels/bg-albania.webp" alt=""
          className="w-full h-full object-cover object-center"
          style={{ imageRendering: 'auto' }}
        />
        <div
          className="absolute inset-0"
          style={{
            background: `linear-gradient(180deg, ${INK}BF 0%, ${INK}80 12%, ${INK}73 50%, ${INK}80 88%, ${INK}C9 100%)`,
          }}
        />
      </div>
      {/* ── Header sticky ── */}
      <header className="sticky top-0 z-40" style={{ background: `${INK}E8`, backdropFilter: 'blur(14px)' }}>
        <div className="max-w-6xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
          <img src="/funnels/hcf-logo.png" alt="HCF Property" className="h-9 w-auto" />
          <a
            href={calendly}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-full h-9 px-5 text-[11px] font-sans font-bold tracking-[0.18em] uppercase transition-transform duration-150 hover:scale-[1.03]"
            style={{ background: GOLD, color: '#143C2B' }}
            data-testid="es-header-cta"
          >
            Reserva la llamada
          </a>
        </div>
        <ScrollProgress />
      </header>

      {/* ════════ 01/09 — DEL LADRILLO AL PATRIMONIO + VÍDEO + FORM ════════ */}
      <Scene n={1} id="top" minH="min-h-[92vh]">
        <div className="my-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center pt-10 pb-6">
          <div className="max-w-2xl">
            <h1 className="text-[2.6rem] sm:text-5xl md:text-6xl xl:text-7xl leading-[1.02] tracking-tight" data-testid="es-hero-title">
              <span style={{ color: IVORY }}>Del ladrillo</span><br />
              <span style={{ color: GOLD }}>al patrimonio</span>
            </h1>
            <p className="mt-6 text-lg md:text-xl leading-relaxed font-sans" style={{ color: IVORY }}>
              No vendemos solo inmuebles.<br className="hidden md:block" />{' '}
              Construimos infraestructuras patrimoniales:<br className="hidden md:block" />{' '}
              activos, cash flow, organización fiscal<br className="hidden md:block" />{' '}
              y continuidad en el tiempo.
            </p>
            <div className="mt-6 w-12 border-t-2" style={{ borderColor: GOLD }} />
            <p className="mt-5 text-base md:text-lg leading-relaxed" style={{ color: SAND }}>
              Primero entiendes el sistema.<br />Luego eliges el territorio.<br />Luego verificas el activo.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row sm:flex-wrap gap-3">
              {/* ★ Fase 96 (Doc 02) — CTA primaria testuale: apre la scelta guidata (#percorso-guidato) */}
              <IvoryPill onClick={() => openGuide('hero_primary')} testId="es-hero-cta" className="!normal-case !tracking-normal !text-[14px] sm:!text-[15px] !font-semibold !py-3 text-left">
                Descubre qué recorrido HCF es coherente con tus objetivos
              </IvoryPill>
              {/* CTA storica mantenuta come secondaria (nessuna cannibalizzazione) */}
              <button
                type="button" onClick={() => scrollTo('ecosistema')}
                className="inline-flex items-center justify-center gap-2 rounded-full w-full sm:w-auto px-6 py-3.5 text-[12px] sm:text-[13px] font-sans font-bold tracking-[0.14em] sm:tracking-[0.2em] uppercase border transition-colors duration-150 hover:bg-white/5"
                style={{ borderColor: GOLD, color: IVORY }}
                data-testid="es-hero-secondary"
              >
                Descubre cómo funciona <PlayCircle className="w-4 h-4" />
              </button>
            </div>
            <NoObligationNote lang="es" theme="dark" className="mt-3 !justify-start" testId="es-hero-no-obligation" compact />
            <div className="mt-9 flex flex-wrap items-center gap-x-0 gap-y-3">
              {[{ icon: Landmark, label: 'Activos' }, { icon: BarChart3, label: 'Cash Flow' }, { icon: Layers, label: 'Estructura' }].map((it, i) => (
                <React.Fragment key={it.label}>
                  {i > 0 && <span className="hidden sm:block h-8 w-px mx-5" style={{ background: `${GOLD}55` }} />}
                  <span className="inline-flex items-center gap-2.5 mr-5 sm:mr-0">
                    <it.icon className="w-5 h-5" style={{ color: GOLD }} strokeWidth={1.6} />
                    <span className="text-sm md:text-base" style={{ color: IVORY }}>{it.label}</span>
                  </span>
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Columna derecha — vídeo (5 min) + formulario */}
          <div className="w-full max-w-xl lg:ml-auto space-y-4" data-testid="es-gate-section">
            <div className="flex items-center gap-3 text-[11px] md:text-xs font-sans font-semibold tracking-[0.3em] uppercase" style={{ color: SAND }}>
              <PlayCircle className="w-4 h-4" style={{ color: GOLD }} />
              El sistema HCF en 5 minutos
              <span className="inline-block flex-1 border-t" style={{ borderColor: `${GOLD}66` }} />
            </div>
            <div className="rounded-2xl overflow-hidden border" style={{ borderColor: `${GOLD}66`, boxShadow: '0 20px 60px rgba(0,0,0,0.45)' }} data-testid="es-prevsl-video">
              <div className="aspect-video"><YT id={PRE_VSL_ID} title="HCF — El sistema en 5 minutos" /></div>
            </div>
            {gSent ? (
              <div className="rounded-2xl border p-6 text-center" style={{ borderColor: `${GOLD}55`, background: `${INK}B8`, backdropFilter: 'blur(16px)' }} data-testid="es-gate-unlocked">
                <CheckCircle2 className="w-10 h-10 mx-auto" style={{ color: GOLD }} />
                <div className="text-xl mt-3" style={{ color: IVORY }}>{assetFromName ? `¡Solicitud ${assetFromName} recibida!` : '¡Solicitud enviada!'}</div>
                <p className="text-sm font-sans mt-1" style={{ color: SAND }}>
                  {assetFromName
                    ? `Hemos recibido tu solicitud sobre ${assetFromName}. Ahora mira los vídeos aquí abajo: primero entiende el sistema, luego reserva la consultoría estratégica con tu Senior Associate.`
                    : 'Recibirás el dossier Albania. Mientras tanto, sigue el recorrido.'}
                </p>
                <a
                  href={calendly} target="_blank" rel="noopener noreferrer"
                  className="ital-gold-btn mt-5 w-full rounded-full min-h-12 py-2.5 px-4 text-[11px] sm:text-[12px] font-sans font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2"
                  data-testid="es-gate-continue"
                >
                  <CalendarClock className="w-4 h-4" /> Reserva la consultoría estratégica
                </a>
              </div>
            ) : (
              <form
                onSubmit={submitHero}
                className="rounded-2xl border p-4 sm:p-5 md:p-6 space-y-3 font-sans"
                style={{ borderColor: `${GOLD}55`, background: `${INK}B8`, backdropFilter: 'blur(16px)', boxShadow: '0 24px 70px rgba(0,0,0,0.45)' }}
              >
                <div className="flex items-center gap-2 text-[11px] font-bold tracking-[0.25em] uppercase" style={{ color: GOLD }}>
                  <FileCheck2 className="w-4 h-4" /> Recibe el dossier Albania
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <LuxField icon={User} value={gName} onChange={(e) => setGName(e.target.value)} placeholder="Nombre y apellidos *" autoComplete="name" testId="es-gate-name" />
                  <LuxField icon={Phone} type="tel" value={gPhone} onChange={(e) => setGPhone(e.target.value)} placeholder="Teléfono (recomendado)" autoComplete="tel" testId="es-gate-phone" />
                </div>
                <LuxField icon={Mail} type="email" value={gEmail} onChange={(e) => setGEmail(e.target.value)} placeholder="Email *" autoComplete="email" testId="es-gate-email" />
                <button
                  type="submit"
                  disabled={gName.trim().length < 2 || !emailRe.test(gEmail.trim()) || gSending}
                  className="ital-gold-btn w-full rounded-full min-h-12 py-2.5 px-4 text-[11px] sm:text-[13px] font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2"
                  data-testid="es-gate-submit"
                >
                  {gSending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Empieza el recorrido
                </button>
                <p className="text-[11px] text-center" style={{ color: SAND }}>
                  Al enviar aceptas nuestra{' '}
                  <Link to="/privacy" className="underline" style={{ color: IVORY }} data-testid="es-gate-privacy">Política de Privacidad</Link>.
                </p>
              </form>
            )}
          </div>
        </div>
      </Scene>

      {/* ════════ ★ Fase 96 (Doc 02) — DOPPIO INGRESSO + SCELTA GUIDATA (paese → obiettivo → landing dedicata) ════════ */}
      <HubGuidedChoice
        calendly={calendly}
        onTerritory={setTerritory}
        scrollTo={scrollTo}
        entry={guideEntry}
        onEntry={setGuideEntry}
        funnel="es"
        lang="es"
        tokens={{ ink: INK, emerald: EMERALD, gold: GOLD, goldDeep: GOLD_DEEP, ivory: IVORY, sand: SAND }}
        id="percorso-guidato"
        testIdPrefix="es-guide"
      />

      {/* ════════ 02/09 — NO ES SOLO INMOBILIARIO + VSL ════════ */}
          <Scene n={2} id="ecosistema">
            <div className="my-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
              <div className="max-w-2xl">
                <Kicker>Ecosistema HCF</Kicker>
                <h2 className="mt-5 text-4xl md:text-5xl xl:text-6xl leading-[1.05] tracking-tight" data-testid="es-s2-title">
                  <span style={{ color: IVORY }}>No es solo</span><br />
                  <span style={{ color: GOLD }}>inmobiliario</span>
                </h2>
                <p className="mt-6 text-base md:text-lg leading-relaxed font-sans" style={{ color: IVORY }}>
                  Un activo por sí solo no basta.<br className="hidden md:block" />{' '}
                  HCF une real estate, lectura del territorio,<br className="hidden md:block" />{' '}
                  verificación sobre el terreno y presencia real<br className="hidden md:block" />{' '}
                  para ayudarte a construir un patrimonio más consciente.
                </p>
                <div className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-y-5">
                  {[{ icon: MapPin, label: 'Territorio' }, { icon: FileCheck2, label: 'Verificación' }, { icon: Landmark, label: 'Real Estate' }, { icon: Users, label: 'Experience' }].map((it, i) => (
                    <div key={it.label} className={`flex flex-col items-start gap-2 ${i > 0 ? 'sm:border-l sm:pl-6' : ''}`} style={{ borderColor: `${GOLD}44` }}>
                      <it.icon className="w-7 h-7" style={{ color: GOLD }} strokeWidth={1.4} />
                      <span className="text-sm md:text-base" style={{ color: IVORY }}>{it.label}</span>
                    </div>
                  ))}
                </div>
                <p className="mt-8 text-base md:text-lg" style={{ color: SAND }}>
                  Primero entiendes el sistema.<br />Luego eliges qué profundizar.
                </p>
              </div>
              <div className="w-full max-w-xl lg:ml-auto space-y-5">
                <div className="flex items-center gap-3 text-[11px] md:text-xs font-sans font-semibold tracking-[0.3em] uppercase" style={{ color: SAND }}>
                  <PlayCircle className="w-4 h-4" style={{ color: GOLD }} />
                  El recorrido contado por quien lo guía
                  <span className="inline-block flex-1 border-t" style={{ borderColor: `${GOLD}66` }} />
                </div>
                <div className="rounded-2xl overflow-hidden border" style={{ borderColor: `${GOLD}66`, boxShadow: '0 20px 60px rgba(0,0,0,0.45)' }} data-testid="es-vsl-video">
                  <div className="aspect-video"><YT id={VSL_ID} title="HCF — VSL Verification Pass" /></div>
                </div>
                <IvoryPill onClick={() => scrollTo('verification')} testId="es-vsl-cta" className="w-full">Descubre el Verification Pass</IvoryPill>
              </div>
            </div>
          </Scene>

          {/* ════════ 03/09 — ¿QUÉ ES UNA INFRAESTRUCTURA PATRIMONIAL? ════════ */}
          <Scene n={3} id="infrastruttura">
            <div className="my-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
              <div className="max-w-2xl">
                <h2 className="text-4xl md:text-5xl xl:text-6xl leading-[1.05] tracking-tight" data-testid="es-s3-title">
                  <span style={{ color: IVORY }}>¿Qué es una</span><br />
                  <span style={{ color: GOLD }}>infraestructura<br />patrimonial?</span>
                </h2>
                <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed font-sans" style={{ color: IVORY }}>
                  El inmueble es solo el primer nivel.
                  El verdadero valor nace cuando activos, cash flow,
                  estructura fiscal y continuidad trabajan juntos.
                </p>
                <div className="mt-10">
                  <span className="text-2xl md:text-3xl" style={{ color: IVORY }}>Adquiere. Produce.<br />Organiza. Transmite.</span>
                  <div className="mt-3 w-16 border-t-2" style={{ borderColor: GOLD }} />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  { n: '01', icon: Landmark, t: 'Activo', d: 'Selección, territorio y due diligence' },
                  { n: '02', icon: BarChart3, t: 'Cash Flow', d: 'Hospitality, demanda real y gestión' },
                  { n: '03', icon: Layers, t: 'Organización fiscal', d: 'Estructura, compliance y protección del neto' },
                  { n: '04', icon: Network, t: 'Herencia', d: 'Governance, trust, VCC y continuidad' },
                ].map((p) => (
                  <div
                    key={p.n}
                    className="rounded-2xl border p-5 md:p-6 transition-transform duration-200 hover:-translate-y-0.5"
                    style={{ borderColor: `${GOLD}55`, background: `${EMERALD}B3`, backdropFilter: 'blur(12px)' }}
                    data-testid={`es-pillar-${p.n}`}
                  >
                    <div className="flex items-center justify-between">
                      <span className="w-12 h-12 rounded-full border grid place-items-center" style={{ borderColor: GOLD }}>
                        <p.icon className="w-6 h-6" style={{ color: GOLD }} strokeWidth={1.4} />
                      </span>
                      <span className="text-xl" style={{ color: `${GOLD}99` }}>{p.n}</span>
                    </div>
                    <div className="mt-4 text-base md:text-lg font-semibold uppercase tracking-wide leading-snug" style={{ color: IVORY }}>{p.t}</div>
                    <p className="mt-1.5 text-sm font-sans leading-relaxed" style={{ color: SAND }}>{p.d}</p>
                  </div>
                ))}
              </div>
            </div>
          </Scene>

          {/* ════════ 04/09 — STEP 1 · TERRITORIO + VERIFICATION PASS ════════ */}
          <Scene n={4} id="verification">
            <div className="my-auto w-full">
              <Kicker>Step 1</Kicker>
              <h2 className="mt-5 text-4xl md:text-5xl xl:text-6xl leading-[1.05] tracking-tight" data-testid="es-s4-title">
                <span style={{ color: IVORY }}>Elige el territorio</span><br />
                <span style={{ color: GOLD }}>a verificar</span>
              </h2>
              <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed font-sans" style={{ color: IVORY }}>
                Cada campaña debe abrir un solo contexto:<br className="hidden md:block" />{' '}
                un país, una lógica, una próxima decisión.
              </p>

              <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
                {/* Territorios — ★ ES: Albania, Indonesia y TAILANDIA activas */}
                <div className="space-y-3" data-testid="es-territories">
                  {[
                    { key: 'AL', tid: 'albania', label: 'Albania', status: 'available', img: '/funnels/indonesia/green-paradise-lombok/photos/gp-07-albania-card.webp' },
                    { key: 'ID', tid: 'indonesia', label: 'Indonesia', status: 'available', img: '/funnels/indonesia/bali-villas/bali-hero.webp' },
                    { key: 'TH', tid: 'tailandia', label: 'Tailandia', status: 'available', note: '€4.000', img: '/funnels/thailand/lux-harmony/lh-hero-sunset.webp' },
                    { key: 'ZB', tid: 'zanzibar', label: 'Zanzíbar', status: 'soldout', iconFallback: Palmtree },
                    { key: 'SP', tid: 'espana', label: 'España', status: 'closed', iconFallback: Building2 },
                  ].map((tr) => {
                    const st = { available: { label: 'Available', dot: '#2FBF71' }, soldout: { label: 'Sold Out', dot: '#E5484D' }, closed: { label: 'Closed', dot: '#8A8577' } }[tr.status];
                    const selectable = tr.status === 'available' || tr.selectable === true;
                    const isSel = selectable && territory === tr.key;
                    return (
                      <button
                        key={tr.key} type="button"
                        onClick={() => { if (!selectable) return; setTerritory(tr.key); scrollTo('vp-card'); }}
                        className="w-full flex items-center gap-4 rounded-xl border p-2.5 pr-4 text-left transition-transform duration-150 hover:scale-[1.01]"
                        style={{
                          borderColor: isSel ? GOLD : `${GOLD}33`,
                          background: isSel ? `${EMERALD}F0` : `${EMERALD}80`,
                          boxShadow: isSel ? `0 0 0 1px ${GOLD}, 0 10px 30px rgba(0,0,0,0.35)` : 'none',
                          opacity: tr.status === 'available' ? 1 : 0.68,
                          cursor: selectable ? 'pointer' : 'default',
                        }}
                        data-testid={`es-territory-${tr.tid}`}
                      >
                        <span className="w-20 h-14 rounded-lg overflow-hidden shrink-0 grid place-items-center" style={{ background: INK }}>
                          {tr.img ? <img src={tr.img} alt={tr.label} className="w-full h-full object-cover" loading="lazy" /> : <tr.iconFallback className="w-6 h-6" style={{ color: `${GOLD}99` }} strokeWidth={1.4} />}
                        </span>
                        <span className="flex-1 min-w-0">
                          <span className="block text-lg tracking-wide uppercase" style={{ color: IVORY }}>{tr.label}</span>
                          <span className="flex items-center gap-1.5 text-xs font-sans" style={{ color: SAND }}>
                            <span className="w-2 h-2 rounded-full inline-block" style={{ background: st.dot }} /> {st.label}{tr.note ? ` · ${tr.note}` : ''}
                          </span>
                        </span>
                        {isSel && (
                          <span className="shrink-0 w-9 h-9 rounded-full grid place-items-center" style={{ background: IVORY }}>
                            <ArrowRight className="w-4 h-4" style={{ color: '#143C2B' }} />
                          </span>
                        )}
                      </button>
                    );
                  })}
                  {/* Vídeo DINÁMICO por territorio bajo la lista de países */}
                  <VpVideoPlaylist
                    videos={vpVideosFor(territory)}
                    lang="es"
                    territory={territory}
                    funnel="es"
                    tokens={{ ink: INK, emerald: EMERALD, gold: GOLD, ivory: IVORY, sand: SAND }}
                    testIdPrefix="es-territory-video"
                    className="!mt-5"
                  />
                </div>

                {/* Card VP + Extra Pass */}
                <div className="space-y-4">
                  <div
                    id="vp-card"
                    className="rounded-2xl border p-5 sm:p-7 md:p-8"
                    style={{ borderColor: `${GOLD}77`, background: `linear-gradient(160deg, ${EMERALD}F5, ${INK}EE)`, backdropFilter: 'blur(16px)', boxShadow: '0 24px 70px rgba(0,0,0,0.5)' }}
                    data-testid="es-vp-card"
                  >
                    <div className="text-2xl md:text-3xl" style={{ color: IVORY }}>Verification Pass</div>
                    <div className="text-4xl md:text-5xl mt-1" style={{ color: GOLD }} data-testid="es-vp-country">{vpCountry.name}</div>
                    <p className="mt-4 text-sm md:text-base font-sans leading-relaxed" style={{ color: IVORY }}>
                      {vpCountry.desc}
                    </p>
                    <div className="mt-6 text-[11px] font-sans font-bold tracking-[0.35em] uppercase" style={{ color: SAND }}>{vpCountry.rateLabel}</div>
                    <div className="flex items-end gap-3">
                      <span className="text-5xl sm:text-6xl md:text-7xl leading-none" style={{ color: GOLD }} data-testid="es-vp-price">{vpCountry.price}</span>
                      <span className="pb-2 text-base font-sans" style={{ color: SAND }}>por persona</span>
                    </div>
                    <div className="mt-6 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 text-[10px] sm:text-[11px] font-sans font-bold tracking-[0.14em] sm:tracking-[0.2em] uppercase" style={{ color: SAND }}>
                      <span>{vp.running ? 'Verification Pass en curso' : 'La próxima fecha empieza en'}</span>
                      <span style={{ color: GOLD }} data-testid="es-vp-next-date">{vp.date.label}</span>
                    </div>
                    <div className="mt-2.5 grid grid-cols-4 gap-2.5" data-testid="es-vp-countdown">
                      {[{ v: vp.d, l: 'Días' }, { v: vp.h, l: 'Horas' }, { v: vp.m, l: 'Min' }, { v: vp.s, l: 'Seg' }].map((b) => (
                        <div key={b.l} className="rounded-lg border py-3 text-center" style={{ borderColor: `${GOLD}55`, background: `${INK}80` }}>
                          <div className="text-xl sm:text-2xl md:text-3xl" style={{ color: IVORY }}>{String(b.v).padStart(2, '0')}</div>
                          <div className="text-[9px] font-sans font-bold tracking-[0.25em] uppercase mt-0.5" style={{ color: SAND }}>{b.l}</div>
                        </div>
                      ))}
                    </div>
                    {/* Fechas oficiales con plazas restantes (por país) */}
                    <div className="mt-5 space-y-2" data-testid="es-vp-dates">
                      {vpActiveDates.map((d) => {
                        const isNext = d.id === vp.date.id;
                        const pct = Math.round((d.left / d.total) * 100);
                        const soldOut = (d.left ?? 0) <= 0;
                        return (
                          <div
                            key={d.id}
                            className="rounded-lg border px-3.5 py-2.5"
                            style={{
                              borderColor: isNext ? GOLD : `${GOLD}33`,
                              background: isNext ? `${INK}B3` : `${INK}66`,
                              boxShadow: isNext ? `0 0 0 1px ${GOLD}` : 'none',
                              opacity: soldOut ? 0.75 : 1,
                            }}
                            data-testid={`es-vp-date-${d.id}`}
                          >
                            <div className="flex items-center justify-between gap-3">
                              <span className="text-sm font-sans font-semibold" style={{ color: IVORY }}>{d.label}</span>
                              <span className="text-[11px] font-sans font-bold tracking-wide uppercase whitespace-nowrap" style={{ color: d.left <= 5 ? '#E5484D' : GOLD }}>
                                {soldOut ? 'Agotado' : `${d.left} plazas de ${d.total}`}
                              </span>
                            </div>
                            <div className="mt-1.5 h-1 rounded-full overflow-hidden" style={{ background: `${GOLD}22` }}>
                              <div className="h-full rounded-full" style={{ width: `${soldOut ? 100 : pct}%`, background: d.left <= 5 ? '#E5484D' : `linear-gradient(90deg, ${GOLD_DEEP}, ${GOLD})` }} />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <button
                      type="button" onClick={() => scrollTo('finale')}
                      className="mt-7 w-full rounded-full min-h-12 py-2.5 px-4 text-[11px] sm:text-[13px] font-sans font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2 transition-transform duration-200 hover:scale-[1.02]"
                      style={{ background: IVORY, color: '#143C2B', boxShadow: `0 0 0 1px ${GOLD}` }}
                      data-testid="es-vp-cta"
                    >
                      Verifica el país <ArrowRight className="w-4 h-4" />
                    </button>
                    <button
                      type="button" onClick={() => scrollTo('finale')}
                      className="mt-3 w-full rounded-full min-h-11 py-2 px-4 text-[11px] sm:text-[12px] font-sans font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2 border transition-colors duration-150 hover:bg-white/5"
                      style={{ borderColor: GOLD, color: IVORY, background: 'transparent' }}
                      data-testid="es-vp-cta-2"
                    >
                      {vpCountry.lockCta} <ArrowRight className="w-4 h-4" />
                    </button>
                  </div>

                  {/* EXTRA PASS PRIVADO (solo Albania · entre semana · €1.000 · máx 5) */}
                  {territory === 'AL' && (
                  <div
                    className="rounded-2xl border p-5 sm:p-6 md:p-7"
                    style={{ borderColor: `${GOLD}99`, background: `linear-gradient(160deg, ${INK}F8, #120D04EE)`, backdropFilter: 'blur(16px)', boxShadow: '0 24px 70px rgba(0,0,0,0.5)' }}
                    data-testid="es-extra-pass-card"
                  >
                    <div className="flex items-center gap-2 text-[11px] font-sans font-bold tracking-[0.3em] uppercase" style={{ color: GOLD }}>
                      <Star className="w-4 h-4" style={{ fill: GOLD }} /> Extra Pass Privado
                    </div>
                    <div className="mt-2 flex items-end gap-3">
                      <span className="text-4xl md:text-5xl leading-none" style={{ color: IVORY }} data-testid="es-extra-pass-price">€1.000</span>
                      <span className="pb-1 text-sm font-sans" style={{ color: SAND }}>entre semana · grupos reducidos</span>
                    </div>
                    <p className="mt-3 text-sm font-sans leading-relaxed" style={{ color: IVORY }}>
                      Dada la gran demanda de los fines de semana, abrimos también
                      <b> fechas entre semana</b> en formato privado:
                      máximo <b>5 inversores</b> por fecha, agenda dedicada.
                    </p>
                    <div className="mt-4 grid grid-cols-2 gap-2" data-testid="es-extra-pass-dates">
                      {extraDates.map((d) => (
                        <div key={d.id} className="rounded-lg border px-3 py-2.5" style={{ borderColor: `${GOLD}44`, background: `${INK}80` }} data-testid={`es-extra-date-${d.id}`}>
                          <div className="text-sm font-sans font-semibold" style={{ color: IVORY }}>{d.label}</div>
                          <div className="text-[11px] font-sans font-bold tracking-wide uppercase mt-0.5" style={{ color: GOLD }}>máx {d.max} inversores</div>
                        </div>
                      ))}
                    </div>
                    <a
                      href={calendly} target="_blank" rel="noopener noreferrer"
                      className="ital-gold-btn mt-5 w-full rounded-full min-h-11 py-2 px-4 text-[11px] sm:text-[12px] font-sans font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2"
                      data-testid="es-extra-pass-cta"
                    >
                      Solicita tu plaza <ArrowRight className="w-4 h-4" />
                    </a>
                  </div>
                  )}
                </div>
              </div>
            </div>
          </Scene>

          {/* ════════ 05/09 — STEP 2 · ELIGE EL ACTIVO ════════ */}
          <Scene n={5} id="asset">
            <div className="my-auto w-full">
              <Kicker>Step 2</Kicker>
              <h2 className="mt-5 text-4xl md:text-5xl xl:text-6xl leading-[1.05] tracking-tight" data-testid="es-s5-title">
                <span style={{ color: IVORY }}>Elige el activo</span><br />
                <span style={{ color: GOLD }}>a profundizar</span>
              </h2>
              <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed font-sans" style={{ color: IVORY }}>
                Después del territorio llega el activo.<br className="hidden md:block" />{' '}
                No un catálogo infinito, sino una selección<br className="hidden md:block" />{' '}
                coherente con el recorrido.
              </p>
              <div className="mt-5 inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-[11px] font-sans font-bold tracking-[0.22em] uppercase" style={{ borderColor: `${GOLD}77`, background: `${INK}B3`, color: GOLD }} data-testid="es-assets-territory-badge">
                <MapPin className="w-3.5 h-3.5" /> Territorio seleccionado: {vpCountry.name}
              </div>
              {territory === 'ID' ? (
              /* Indonesia: cards compactas → mini-landing dedicadas */
              <IndonesiaAssetCards
                cards={INDONESIA_CARDS}
                tokens={{ gold: GOLD, ivory: IVORY, sand: SAND, emerald: EMERALD }}
                ctaLabel="Descubre más"
                testIdPrefix="es-id"
                funnel="es"
              />
              ) : territory === 'TH' ? (
              /* ★ Tailandia ACTIVA: cards producto en llegada (el cliente
                 enviará las gráficas). Mientras: VP €4.000 reservable. */
              <div className="mt-8 rounded-2xl border p-5 sm:p-7 md:p-8 max-w-2xl" style={{ borderColor: `${GOLD}55`, background: `${EMERALD}B3`, backdropFilter: 'blur(12px)' }} data-testid="es-assets-th-soon">
                <div className="text-2xl md:text-3xl leading-snug" style={{ color: IVORY }}>
                  Selección Tailandia<br /><span style={{ color: GOLD }}>muy pronto disponible</span>
                </div>
                <p className="mt-3 text-sm md:text-base font-sans leading-relaxed" style={{ color: SAND }}>
                  Las fichas de producto llegan en breve. Mientras tanto el
                  Verification Pass Tailandia (€4.000 · privado · todo incluido ·
                  Chumphon + Bangkok + Koh Tao) ya está activo y reservable.
                </p>
                <button
                  type="button" onClick={() => scrollTo('finale')}
                  className="ital-gold-btn mt-6 rounded-full h-11 px-7 text-[12px] font-sans font-bold tracking-[0.2em] uppercase inline-flex items-center justify-center gap-2"
                  data-testid="es-assets-th-cta"
                >
                  Reserva tu verificación <ArrowRight className="w-4 h-4" />
                </button>
              </div>
              ) : sceneAssets.length > 0 ? (
              <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="es-assets-grid">
                {sceneAssets.map((p) => (
                  <div key={p.slug} className="group rounded-2xl border overflow-hidden transition-transform duration-200 hover:-translate-y-0.5" style={{ borderColor: `${GOLD}55`, background: `${EMERALD}CC` }} data-testid={`es-asset-${p.slug}`}>
                    <div className="h-44 overflow-hidden">
                      <img src={p.image_url || p.hero_image} alt={p.name} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.04]" loading="lazy" />
                    </div>
                    <div className="p-5">
                      <div className="text-xl uppercase tracking-wide" style={{ color: IVORY }}>{p.short_name || p.name}</div>
                      <p className="mt-1.5 text-sm font-sans leading-snug" style={{ color: SAND }}>{assetCopy[p.slug] || p.tagline}</p>
                      <Link to={assetHref(p.slug)} data-testid={`es-asset-cta-${p.slug}`}>
                        <span className="mt-4 w-full rounded-full h-10 text-[11px] font-sans font-bold tracking-[0.22em] uppercase inline-flex items-center justify-center gap-2 transition-transform duration-150 hover:scale-[1.02]" style={{ background: IVORY, color: '#143C2B', boxShadow: `0 0 0 1px ${GOLD}` }}>
                          Profundiza <ArrowRight className="w-3.5 h-3.5" />
                        </span>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              ) : (
              <div className="mt-8 rounded-2xl border p-5 sm:p-7 md:p-8 max-w-2xl" style={{ borderColor: `${GOLD}55`, background: `${EMERALD}B3`, backdropFilter: 'blur(12px)' }} data-testid="es-assets-empty">
                <div className="text-2xl md:text-3xl leading-snug" style={{ color: IVORY }}>
                  Selección {vpCountry.name}<br /><span style={{ color: GOLD }}>momentáneamente agotada</span>
                </div>
                <p className="mt-3 text-sm md:text-base font-sans leading-relaxed" style={{ color: SAND }}>
                  Los activos de este territorio están agotados.
                  Déjanos tus datos: te avisamos en cuanto abramos la próxima selección.
                </p>
                <button
                  type="button" onClick={() => scrollTo('finale')}
                  className="ital-gold-btn mt-6 rounded-full h-11 px-7 text-[12px] font-sans font-bold tracking-[0.2em] uppercase inline-flex items-center justify-center gap-2"
                  data-testid="es-assets-empty-cta"
                >
                  Avísame <ArrowRight className="w-4 h-4" />
                </button>
              </div>
              )}
              <p className="mt-10 text-xl md:text-2xl leading-snug" style={{ color: IVORY }}>
                No tienes que elegir hoy el correcto.<br className="hidden md:block" />{' '}
                Tienes que entender cuál merece atención.
              </p>
              <div className="mt-3 w-12 border-t-2" style={{ borderColor: GOLD }} />
            </div>
          </Scene>

          {/* ════════ 06/09 — EL RENDIMIENTO NO NACE EN EL RENDER ════════ */}
          <Scene n={6} id="rendimento">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <img src="/funnels/hcf-logo.png" alt="HCF Property" className="h-8 w-auto" />
                <span className="h-6 w-px" style={{ background: `${GOLD}55` }} />
                <img src="/funnels/hcf-travel-logo.png" alt="HCF Travel" className="h-8 w-auto" data-testid="es-travel-logo" />
              </div>
            </div>
            <div className="my-auto w-full grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,420px)] gap-10 lg:gap-14 items-center">
              <div className="max-w-2xl">
              <h2 className="text-4xl md:text-5xl xl:text-6xl leading-[1.05] tracking-tight" data-testid="es-s6-title">
                <span style={{ color: IVORY }}>El rendimiento</span><br />
                <span style={{ color: GOLD }}>no nace<br />en el render</span>
              </h2>
              <p className="mt-4 text-2xl md:text-3xl" style={{ color: IVORY }}>Nace de la demanda real.</p>
              <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed font-sans" style={{ color: IVORY }}>
                Por eso la lectura del territorio no parte
                solo del real estate. El tour operator añade
                una lente concreta sobre flujos, ocupación,
                estancia y comportamiento del viajero.
              </p>
              <div className="mt-6 w-12 border-t-2" style={{ borderColor: GOLD }} />
              <div className="mt-7">
                <a
                  href="/funnels/certificato-tour-operator.pdf" target="_blank" rel="noopener noreferrer"
                  className="inline-flex w-full sm:w-auto items-center justify-center text-center gap-2 rounded-2xl sm:rounded-full px-5 sm:px-7 py-3.5 text-[11px] sm:text-[12px] font-sans font-bold tracking-[0.14em] sm:tracking-[0.22em] uppercase transition-transform duration-150 hover:scale-[1.02]"
                  style={{ background: IVORY, color: '#143C2B', boxShadow: `0 0 0 1px ${GOLD}` }}
                  data-testid="es-tour-operator-badge"
                >
                  <FileCheck2 className="w-4 h-4" /> Tour Operator Registrado · Ver el certificado
                </a>
              </div>
              <div className="mt-10 grid grid-cols-3 gap-2 max-w-lg">
                {[{ icon: Users, label: 'Flujos turísticos' }, { icon: BedDouble, label: 'Ocupación' }, { icon: CalendarClock, label: 'Estancia media' }].map((it, i) => (
                  <div key={it.label} className={`flex flex-col items-start gap-2 ${i > 0 ? 'border-l pl-4' : ''}`} style={{ borderColor: `${GOLD}44` }}>
                    <it.icon className="w-7 h-7" style={{ color: GOLD }} strokeWidth={1.4} />
                    <span className="text-sm md:text-base leading-tight" style={{ color: IVORY }}>{it.label}</span>
                  </div>
                ))}
              </div>
              <div className="mt-12">
                <div className="text-xl md:text-2xl" style={{ color: GOLD }}>Datos reales &gt; hipótesis</div>
                <p className="text-sm md:text-base font-sans mt-1" style={{ color: SAND }}>Antes del proyecto viene el territorio.</p>
              </div>
              </div>

              {/* Certificado oficial Tour Operator (HCF Travel) */}
              <div
                className="w-full rounded-2xl border p-5 font-sans"
                style={{ borderColor: `${GOLD}66`, background: `${INK}C4`, backdropFilter: 'blur(14px)', boxShadow: '0 24px 70px rgba(0,0,0,0.45)' }}
                data-testid="es-certificate-card"
              >
                <div className="flex items-center justify-between gap-3">
                  <img src="/funnels/hcf-travel-logo.png" alt="HCF Travel" className="h-7 w-auto" />
                  <span className="inline-flex items-center gap-1.5 text-[10px] font-bold tracking-[0.2em] uppercase" style={{ color: GOLD }}>
                    <ShieldCheck className="w-4 h-4" /> Certificado oficial
                  </span>
                </div>
                <a href="/funnels/certificato-tour-operator.pdf" target="_blank" rel="noopener noreferrer" className="block mt-4 group" data-testid="es-certificate-preview">
                  <div className="rounded-xl overflow-hidden border transition-transform duration-200 group-hover:scale-[1.015]" style={{ borderColor: `${GOLD}55` }}>
                    <img
                      src="/funnels/certificato-tour-operator.jpg"
                      alt="Certificado de registro Tour Operator — HCF Travel"
                      className="w-full h-auto"
                      loading="lazy"
                    />
                  </div>
                </a>
                <p className="mt-3 text-[12px] leading-relaxed" style={{ color: SAND }}>
                  Registro Tour Operator <b style={{ color: IVORY }}>№ RK-01-8681</b> —
                  Ministerio de Turismo, expedido a <b style={{ color: IVORY }}>HCF Travel</b>.
                </p>
                <a
                  href="/funnels/certificato-tour-operator.pdf" target="_blank" rel="noopener noreferrer"
                  className="mt-3 w-full rounded-full h-10 text-[11px] font-bold tracking-[0.2em] uppercase inline-flex items-center justify-center gap-2 border transition-colors duration-150 hover:bg-white/5"
                  style={{ borderColor: GOLD, color: IVORY }}
                  data-testid="es-certificate-open"
                >
                  Abre el certificado (PDF) <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          </Scene>

          {/* ════════ 07/09 — PRUEBAS, NO PROMESAS (testimonios) ════════ */}
          <Scene n={7} id="prove">
            <div className="my-auto w-full grid grid-cols-1 lg:grid-cols-[minmax(0,440px)_1fr] gap-10 lg:gap-14 items-center">
              <div>
                <Kicker>Pruebas</Kicker>
                <h2 className="mt-5 text-4xl md:text-5xl xl:text-6xl leading-[1.05] tracking-tight" data-testid="es-s7-title">
                  <span style={{ color: IVORY }}>Pruebas,</span><br />
                  <span style={{ color: GOLD }}>no promesas</span>
                </h2>
                <p className="mt-5 text-base md:text-lg leading-relaxed font-sans" style={{ color: IVORY }}>
                  Clientes reales, experiencias reales y<br className="hidden md:block" />{' '}
                  preguntas incómodas afrontadas abiertamente.
                </p>
                <a
                  href="https://www.trustpilot.com/review/housecashflows.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-8 inline-flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl sm:rounded-full border px-5 sm:px-6 py-3 transition-transform duration-150 hover:scale-[1.02]"
                  style={{ borderColor: `${GOLD}66`, background: `${EMERALD}B3` }}
                  data-testid="es-trustpilot-link"
                >
                  <span className="w-7 h-7 rounded-md grid place-items-center shrink-0" style={{ background: '#00B67A' }}>
                    <Star className="w-4 h-4" style={{ color: '#fff', fill: '#fff' }} />
                  </span>
                  <span className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" style={{ color: '#00B67A', fill: '#00B67A' }} />)}
                  </span>
                  <span className="hidden sm:block h-5 w-px" style={{ background: `${GOLD}55` }} />
                  <span className="text-sm font-sans" style={{ color: IVORY }}>
                    Reseñas verificables en <b>Trustpilot</b>
                  </span>
                  <ArrowRight className="w-4 h-4" style={{ color: GOLD }} />
                </a>
                <p className="mt-10 text-xl md:text-2xl leading-snug" style={{ color: IVORY }}>
                  La credibilidad se construye<br className="hidden md:block" />{' '}
                  mostrando el recorrido, no solo contándolo.
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="es-testimonials-grid">
                {TESTIMONIALS_FEATURED.map((v) => <TestimonialCard key={v.id} id={v.id} label={v.label} name={v.name} />)}
              </div>
            </div>
            {/* ★ 2026-10-19 — más testimonios (9 nuevos + reseña completa), expandibles */}
            {TESTIMONIALS_MORE.length > 0 && (
              <div className="mt-8 w-full">
                {showAllTestimonials ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="es-testimonials-more-grid">
                    {TESTIMONIALS_MORE.map((v) => <TestimonialCard key={v.id} id={v.id} label={v.label} name={v.name} />)}
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => setShowAllTestimonials(true)}
                    className="mx-auto flex items-center gap-3 rounded-full border px-6 py-3 text-sm font-sans transition-transform duration-150 hover:scale-[1.02]"
                    style={{ borderColor: `${GOLD}99`, background: `${EMERALD}B3`, color: IVORY }}
                    data-testid="es-testimonials-show-more"
                  >
                    <PlayCircle className="w-5 h-5" style={{ color: GOLD }} strokeWidth={1.4} />
                    Ver {TESTIMONIALS_MORE.length} testimonios más
                    <ArrowRight className="w-4 h-4" style={{ color: GOLD }} />
                  </button>
                )}
              </div>
            )}
          </Scene>

          {/* ════════ 08/09 — STEP 3 · COMPLETA TU ESTRUCTURA ════════ */}
          <Scene n={8} id="struttura">
            <div className="my-auto w-full">
              <Kicker>Step 3</Kicker>
              <h2 className="mt-5 text-4xl md:text-5xl xl:text-6xl leading-[1.05] tracking-tight" data-testid="es-s8-title">
                <span style={{ color: IVORY }}>Completa</span><br />
                <span style={{ color: GOLD }}>tu estructura</span>
              </h2>
              <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed font-sans" style={{ color: IVORY }}>
                A partir de aquí no hace falta hacer más clics.<br className="hidden md:block" />{' '}
                Hace falta entender tu caso con un Senior Associate.
              </p>
              <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {/* Path checklist */}
                <div className="rounded-2xl border p-5 sm:p-6" style={{ borderColor: `${GOLD}55`, background: `${EMERALD}B3`, backdropFilter: 'blur(12px)' }} data-testid="es-path-card">
                  <div className="text-[11px] font-sans font-bold tracking-[0.3em] uppercase" style={{ color: IVORY }}>Your HCF Path</div>
                  <div className="mt-4 divide-y" style={{ borderColor: `${GOLD}33` }}>
                    {[
                      { icon: MapPin, k: 'Territorio', v: 'Albania', done: true },
                      { icon: FileCheck2, k: 'Verification', v: 'Pass', done: true },
                      { icon: Landmark, k: 'Activo', v: 'Narea', done: true },
                      { icon: BarChart3, k: 'Cash Flow', v: 'Por configurar', done: false },
                      { icon: Layers, k: 'Fiscal', v: 'Por configurar', done: false },
                      { icon: Users, k: 'Patrimonio', v: 'Por configurar', done: false },
                    ].map((r) => (
                      <div key={r.k} className="flex items-center gap-3 py-3" style={{ borderColor: `${GOLD}33` }}>
                        <r.icon className="w-5 h-5 shrink-0" style={{ color: GOLD }} strokeWidth={1.5} />
                        <span className="w-24 text-sm" style={{ color: IVORY }}>{r.k}</span>
                        <span className="flex-1 text-sm font-sans" style={{ color: r.done ? IVORY : SAND }}>{r.v}</span>
                        {r.done
                          ? <CheckCircle2 className="w-5 h-5 shrink-0" style={{ color: GOLD }} />
                          : <Circle className="w-5 h-5 shrink-0" style={{ color: `${SAND}88` }} strokeWidth={1} strokeDasharray="3 3" />}
                      </div>
                    ))}
                  </div>
                </div>
                {/* Sesión Senior */}
                <div className="rounded-2xl border p-5 sm:p-6 flex flex-col" style={{ borderColor: `${GOLD}55`, background: `${EMERALD}B3`, backdropFilter: 'blur(12px)' }} data-testid="es-session-card">
                  <span className="w-14 h-14 rounded-full border grid place-items-center" style={{ borderColor: GOLD }}>
                    <Users className="w-7 h-7" style={{ color: GOLD }} strokeWidth={1.3} />
                  </span>
                  <div className="mt-4 text-2xl leading-snug" style={{ color: IVORY }}>Sesión con<br />Senior Associate</div>
                  <div className="mt-2 w-10 border-t" style={{ borderColor: GOLD }} />
                  <ul className="mt-4 space-y-2.5 text-sm font-sans" style={{ color: IVORY }}>
                    {['objetivo', 'uso', 'presupuesto', 'documentos', 'estructura'].map((x) => (
                      <li key={x} className="flex items-center gap-2.5">
                        <span className="w-2 h-2 rounded-full border" style={{ borderColor: GOLD }} /> {x}
                      </li>
                    ))}
                  </ul>
                  <a href={calendly} target="_blank" rel="noopener noreferrer" className="mt-auto pt-6" data-testid="es-book-session">
                    <span className="w-full rounded-full min-h-11 py-2 px-4 text-[11px] sm:text-[12px] font-sans font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2 transition-transform duration-150 hover:scale-[1.02]" style={{ background: IVORY, color: '#143C2B', boxShadow: `0 0 0 1px ${GOLD}` }}>
                      Reserva la sesión <ArrowRight className="w-4 h-4" />
                    </span>
                  </a>
                </div>
                {/* El riesgo cero no existe */}
                <div className="rounded-2xl border p-5 sm:p-6 flex flex-col md:col-span-2 lg:col-span-1" style={{ borderColor: `${GOLD}55`, background: `${EMERALD}B3`, backdropFilter: 'blur(12px)' }} data-testid="es-risk-card">
                  <span className="w-14 h-14 rounded-full border grid place-items-center" style={{ borderColor: GOLD }}>
                    <ShieldCheck className="w-7 h-7" style={{ color: GOLD }} strokeWidth={1.3} />
                  </span>
                  <div className="mt-4 text-2xl leading-snug" style={{ color: IVORY }}>El riesgo cero<br />no existe</div>
                  <div className="mt-2 w-10 border-t" style={{ borderColor: GOLD }} />
                  <p className="mt-4 text-sm font-sans leading-relaxed" style={{ color: IVORY }}>
                    Lo hacemos más verificable: territorio, activo
                    y datos se comprueban en persona, antes de decidir.
                  </p>
                  <ul className="mt-4 space-y-2.5 text-sm font-sans" style={{ color: IVORY }}>
                    {['verificación sobre el terreno', 'datos del territorio', 'sin obligación de compra'].map((x) => (
                      <li key={x} className="flex items-center gap-2.5">
                        <CheckCircle2 className="w-4 h-4 shrink-0" style={{ color: GOLD }} /> {x}
                      </li>
                    ))}
                  </ul>
                  <a href={calendly} target="_blank" rel="noopener noreferrer" className="mt-auto pt-6" data-testid="es-risk-cta">
                    <span className="w-full rounded-full min-h-11 py-2 px-4 text-[11px] sm:text-[12px] font-sans font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2 border transition-colors duration-150 hover:bg-white/5" style={{ borderColor: GOLD, color: IVORY }}>
                      Habla con tu Senior Associate <ArrowRight className="w-4 h-4" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </Scene>

          {/* ════════ 09/09 — FINAL CTA · EMPIEZA LA VERIFICACIÓN ════════ */}
          <Scene n={9} id="finale">
            <div className="my-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
              <div className="max-w-2xl">
                <Kicker>Final CTA</Kicker>
                <h2 className="mt-5 text-[2.6rem] sm:text-5xl md:text-6xl xl:text-7xl leading-[1.02] tracking-tight" data-testid="es-s9-title">
                  <span style={{ color: IVORY }}>Empieza la</span><br />
                  <span style={{ color: GOLD }}>verificación</span>
                </h2>
                <p className="mt-6 text-lg md:text-xl leading-relaxed font-sans" style={{ color: IVORY }}>
                  Primero entiendes el sistema.<br />Luego verificas el territorio.<br />Luego eliges el activo.
                </p>
                <div className="mt-6 w-12 border-t-2" style={{ borderColor: GOLD }} />
                <p className="mt-5 text-base md:text-lg leading-relaxed" style={{ color: SAND }}>
                  HCF no te pide comprar hoy.<br className="hidden md:block" />{' '}
                  Te ayuda a entender qué merece la pena profundizar.
                </p>
                <div className="mt-10 flex flex-wrap items-center gap-x-0 gap-y-3">
                  {[{ icon: Landmark, label: 'Activos' }, { icon: BarChart3, label: 'Cash Flow' }, { icon: Layers, label: 'Continuidad' }].map((it, i) => (
                    <React.Fragment key={it.label}>
                      {i > 0 && <span className="hidden sm:block h-8 w-px mx-5" style={{ background: `${GOLD}55` }} />}
                      <span className="inline-flex items-center gap-2.5 mr-5 sm:mr-0">
                        <it.icon className="w-5 h-5" style={{ color: GOLD }} strokeWidth={1.6} />
                        <span className="text-sm md:text-base" style={{ color: IVORY }}>{it.label}</span>
                      </span>
                    </React.Fragment>
                  ))}
                </div>
              </div>

              <div className="w-full max-w-xl lg:ml-auto">
                {fSent ? (
                  <div className="rounded-2xl border p-6 sm:p-8 text-center" style={{ borderColor: `${GOLD}55`, background: `${INK}B3`, backdropFilter: 'blur(14px)' }} data-testid="es-final-success">
                    <CheckCircle2 className="w-12 h-12 mx-auto" style={{ color: GOLD }} />
                    <div className="text-2xl mt-4" style={{ color: IVORY }}>¡Solicitud enviada!</div>
                    <p className="text-sm font-sans mt-1" style={{ color: SAND }}>Recibirás el dossier y un Senior Associate te contactará en breve.</p>
                  </div>
                ) : (
                  <form
                    onSubmit={submitFinal}
                    className="rounded-2xl border p-5 sm:p-6 md:p-7 space-y-3.5 font-sans"
                    style={{ borderColor: `${GOLD}55`, background: `${INK}B8`, backdropFilter: 'blur(16px)', boxShadow: '0 24px 70px rgba(0,0,0,0.45)' }}
                    data-testid="es-final-form"
                  >
                    <div className="flex items-center gap-2 text-[11px] font-bold tracking-[0.25em] uppercase" style={{ color: GOLD }}>
                      <FileCheck2 className="w-4 h-4" /> Recibe el dossier {vpCountry.name}
                    </div>
                    <LuxField icon={User} placeholder="Nombre y apellidos *" value={fName} onChange={(e) => setFName(e.target.value)} autoComplete="name" testId="es-final-name" />
                    <LuxField icon={Mail} type="email" placeholder="Email *" value={fEmail} onChange={(e) => setFEmail(e.target.value)} autoComplete="email" testId="es-final-email" />
                    <LuxField icon={Phone} type="tel" placeholder="Teléfono (recomendado)" value={fPhone} onChange={(e) => setFPhone(e.target.value)} autoComplete="tel" testId="es-final-phone" />
                    <button
                      type="submit"
                      disabled={fName.trim().length < 2 || !emailRe.test(fEmail.trim()) || fSending}
                      className="ital-gold-btn w-full rounded-full min-h-12 py-2.5 px-4 text-[11px] sm:text-[13px] font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2"
                      data-testid="es-final-submit"
                    >
                      {fSending ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Recibe el dossier <ArrowRight className="w-4 h-4" />
                    </button>
                    <a href={calendly} target="_blank" rel="noopener noreferrer" data-testid="es-final-booking">
                      <span className="mt-1 w-full rounded-full min-h-12 py-2.5 px-4 text-[11px] sm:text-[12px] font-bold tracking-[0.12em] sm:tracking-[0.2em] uppercase text-center leading-snug inline-flex items-center justify-center gap-2 border transition-colors duration-150 hover:bg-white/5" style={{ borderColor: GOLD, color: IVORY }}>
                        Reserva la consultoría estratégica <ArrowRight className="w-4 h-4" />
                      </span>
                    </a>
                    {/* ★ Fase 96 (Doc 02) — microcopy completa */}
                    <NoObligationNote lang="es" theme="dark" color={IVORY} iconColor={GOLD} className="pt-1" testId="es-final-no-obligation" />
                  </form>
                )}
              </div>
            </div>
          </Scene>

      {/* ── Footer ── */}
      <footer className="relative border-t" style={{ background: `${INK}D9`, backdropFilter: 'blur(10px)', borderColor: `${GOLD}26` }}>
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
          <div>
            <img src="/funnels/hcf-logo.png" alt="HCF Property" className="h-8" />
            <p className="text-[11px] font-sans mt-2" style={{ color: SAND }}>© {new Date().getFullYear()} HCF Property</p>
          </div>
          <div className="flex gap-5 text-xs font-sans items-center" style={{ color: SAND }}>
            <Link to="/privacy" className="underline hover:opacity-80" data-testid="es-footer-privacy">Privacidad</Link>
            <Link to="/terms" className="underline hover:opacity-80" data-testid="es-footer-terms">Términos</Link>
            <Link to="/cookie-policy" className="underline hover:opacity-80" data-testid="es-footer-cookies">Cookies</Link>
            <span className="tracking-[0.25em]" data-testid="es-footer-code">ES</span>
          </div>
        </div>
      </footer>

      {/* Exit intent: último aviso con Calendly */}
      <ExitIntentModal calendly={calendly} />

      {/* Chat dedicada del funnel ES (prompt spagnolo, lead → Sofia) */}
      <FunnelChatWidget funnel="es" language="es" bookingUrl="/es/booking?rep=richard" />
    </div>
  );
}
